<template>
  <!-- 合伙人数据订单列表对话框 -->
  <el-dialog
    title="订单列表"
    :visible.sync="show"
    :before-close="closeDialog"
    append-to-body
    width="80%"
  >
    <div style="width: 95%; margin: 0 auto">
 

      <!-- 表格 -->
      <el-table
        :data="tableData"
        max-height="500"
        ref="multipleTable"
        header-cell-class-name="table-header"
      >
        <el-table-column prop="billno" label="单号"> </el-table-column>
        <el-table-column prop="create_time" label="支付时间"> </el-table-column>

        <el-table-column prop="driver_phone" label="司机电话"> </el-table-column>
        <el-table-column prop="first.name" label="一级合伙人"> </el-table-column>
        <el-table-column prop="second.name" label="二级合伙人"> </el-table-column>
        <el-table-column prop="order_amount" label="支付金额"> </el-table-column>
     
      </el-table>

      <!-- element ui 原生分页组件 -->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="search_data_children.page"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="search_data_children.limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="result_data.count"
        >
        </el-pagination>
      </div>
    </div>
  </el-dialog>
</template>

<script>
var _this;


export default {
  props: {
    isShow: Boolean,
    data: "",
  },

  components: {},
  watch: {
    isShow(newData, oldData) {
      _this.show = true;
    
      _this.search_data_children.user_phone = _this.data.user_phone;


      _this.searchGetOrderLists();
    },
  },
  data() {
    return {
      show: false,
      result_data: {},
      tableData: [],

      //翻页数据
      search_data_children: {
        page: 1,
        limit: 10,
        user_phone: "",
  
      },
  

      search_rules_children: {
        page: {
          placeholder: "页码",
          rules: {
            required: true,
            message: "页码需要大于0",
            regulation: "gt",
            rulesData: 0,
          },
        },
        limit: {
          placeholder: "每页个数",
          rules: {
            required: true,
            message: "每页个数需在1-51之内",
            regulation: "between",
            rulesData: [1, 51],
          },
        },
      },
    };
  },
  created() {
    _this = this;
  },
  methods: {

    searchGetOrderLists() {
      _this.search_data_children.page = 1;
      _this.getOrderLists();
    },

    // 获取账单信息
    getOrderLists() {
     _this
        .$post("/distribution/getOrderLists", _this.search_data_children)
        .then((res) => {
          // 将获取到的数据赋值

          _this.tableData = res.data;
          _this.result_data = res;
        })
        .catch((err) => {});
    },

    //下拉条（每页显示多少数据）变化
    handleSizeChange(val) {
      _this.search_data_children.limit = val;

      //初始化列表
      _this.getOrderLists();
    },
    //页码变化
    handleCurrentChange(val) {
      _this.search_data_children.page = val;

      //初始化列表
      _this.getOrderLists();
    },

    // 关闭方法
    closeDialog() {
      _this.show = false;
       _this.result_data= {};
     
      _this.tableData = [];

      _this.search_data_children = {
        page: 1,
        limit: 10,
        user_phone: "",
     
      };
    },
  },
};
</script>

<style scoped>
.search_style {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
.driver_water {
  color: #606266;
  margin-bottom: 20px;
}
.form-box {
  padding: 20px;
  box-sizing: border-box;
  margin-right: 0;
  width: 100%;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.el-form-second {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.avatar-uploader {
  width: 100px;
  height: 100px;
}

.capital-title {
  border-bottom: 1px solid rgb(238, 238, 238);
  padding-bottom: 10px;
  margin-bottom: 10px;
}

h2 {
  font-family: Microsoft YaHei;
  font-weight: 600;
  line-height: 21px;
  color: #222;
  font-size: 18px;
  margin-bottom: 20px;
}

.text {
  border-bottom: 1px solid rgb(238, 238, 238);
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.text > span {
  margin-right: 10px;
}
.money-box {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
.money {
  margin-left: 5px;
}
.orange {
  color: rgb(255, 149, 11);
  font-weight: 600;
}
</style>
<style>
.edit-driver .el-tabs__item.is-top.is-active {
  border: 0 !important;
}
.el-date-range-picker__time-header {
  display: block;
}
</style>




